<template>
  <div id="app" class="min-h-screen overflow-x-hidden bg-gradient-to-br from-primary-50 dark:from-secondary-900
    to-secondary-10 dark:to-secondary-900 h-full">
    <!-- Navigation Atas (disembunyikan di desktop) -->
    <nav class="fixed bottom-0 w-full z-50 glass-effect md:hidden backdrop-blur-sm">
      <div class="container mx-auto px-4 py-4">
        <div class="flex items-center justify-between">
          <div class="text-2xl font-bold text-gradient"></div>
          <div
            class="flex flex-row justify-around w-full items-center gap-4 text-sm text-slate-700 dark:text-slate-300">
            <router-link to="/"
              class="hover:text-primary-600 transition-colors pb-2 border-b-2 border-transparent router-link-active:border-primary-600 router-link-active:text-primary-600">
              <i class="fas fa-home"></i>
            </router-link>
            <router-link to="/about"
              class="hover:text-primary-600 transition-colors pb-2 border-b-2 border-transparent router-link-active:border-primary-600 router-link-active:text-primary-600">
              <i class="fas fa-user"></i>
            </router-link>
            <router-link to="/projects"
              class="hover:text-primary-600 transition-colors pb-2 border-b-2 border-transparent router-link-active:border-primary-600 router-link-active:text-primary-600">
              <i class="fas fa-project-diagram"></i>
            </router-link>
            <router-link to="/skills"
              class="hover:text-primary-600 transition-colors pb-2 border-b-2 border-transparent router-link-active:border-primary-600 router-link-active:text-primary-600">
              <i class="fas fa-cog"></i>
            </router-link>
            <!-- <router-link to="/contact" class="hover:text-primary-600 transition-colors">Kontak</router-link> -->
          </div>
        </div>
      </div>
    </nav>

    <!-- Sidebar Navigasi Kanan (hanya tampil di desktop) -->
    <aside
      class="bg-slate-300/50 dark:bg-slate-700/50 text-slate-700 dark:text-slate-300 backdrop-blur-sm fixed top-1/2 -translate-y-1/2 left-0 w-16 py-5 px-1 rounded-r-lg z-40 hidden md:flex flex-col items-center justify-center space-y-8">
      <router-link to="/" class="hover:text-primary-600 transition-colors"><i class="fas fa-home"></i></router-link>
      <router-link to="/about" class="hover:text-primary-600 transition-colors"><i
          class="fas fa-user"></i></router-link>
      <router-link to="/projects" class="hover:text-primary-600 transition-colors"><i
          class="fas fa-project-diagram"></i></router-link>
      <router-link to="/skills" class="hover:text-primary-600 transition-colors"><i
          class="fas fa-cog"></i></router-link>
      <!-- <router-link to="/contact" class="hover:text-primary-600 transition-colors"><i
          class="fas fa-envelope"></i></router-link> -->
    </aside>

    <!-- Sticky Dark Mode Toggle -->
    <button class="darkmode-toggle w-10 h-10 rounded-full flex items-center justify-center" @click="toggleDarkMode">
      <i :class="isDark ? 'fas fa-sun' : 'fas fa-moon'"></i>
    </button>

    <div class="flex flex-col justify-between h-screen">
      <!-- Main Content -->
      <main>
        <transition name="slide" mode="out-in">
          <router-view />
        </transition>
      </main>
      <!-- Footer -->
      <!-- <footer class="bg-slate-900 text-white py-1">
        <div class="container mx-auto px-4 text-center text-xs">
          <p class="hidden">&copy; 2024 Portofolio. Dibuat dengan ❤️ menggunakan Vue.js & Tailwind CSS</p>
        </div>
      </footer> -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      isDark: false
    }
  },
  mounted() {
    // Cek preferensi dark mode dari localStorage
    this.isDark = localStorage.getItem('theme') === 'dark' ||
      (localStorage.getItem('theme') === null && window.matchMedia('(prefers-color-scheme: dark)').matches)
    this.applyDarkMode()
  },
  methods: {
    toggleDarkMode() {
      this.isDark = !this.isDark
      localStorage.setItem('theme', this.isDark ? 'dark' : 'light')
      this.applyDarkMode()
    },
    applyDarkMode() {
      if (this.isDark) {
        document.documentElement.classList.add('dark')
      } else {
        document.documentElement.classList.remove('dark')
      }
    }
  }
}
</script>

<style>
.slide-enter-active,
.slide-leave-active {
  transition: all 0.4s cubic-bezier(.55, 0, .1, 1);
}

.slide-enter-from,
.slide-leave-to {
  opacity: 0;
  transform: translateX(40px);
}

.slide-enter-to,
.slide-leave-from {
  opacity: 1;
  transform: translateX(0);
}
</style>